import React, { useState, useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import HomeIcon from "@mui/icons-material/Home";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
  Modal,
  Box,
  Link,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import { useLocation } from "react-router-dom";
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import "./Employee_Base.css";
import { useAuth } from "../Auth/AuthContext";
import { Tooltip } from "@mui/material";
import { Table } from "react-bootstrap";


const Base = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { logout, employee } = useAuth();


  const [isOpen, setIsOpen] = useState(() => {
    const savedSidebarState = localStorage.getItem("sidebarOpen");
    return savedSidebarState ? JSON.parse(savedSidebarState) : false;
  });



  const [openAccount, setOpenAccount] = useState(false);

  const [openemployeesection, setopenemployeesection] = useState(
    currentPath.includes("/employee/add_employee") ||
    currentPath.includes("/employee/employee_list") ||
    currentPath.includes("/employee/employee_tree") ||
    currentPath.includes("/employee/employee_wallet_amount") ||
    currentPath.includes("/employee/employee_wallet_transcation_list")
  );

  const [opencustomersection, setopencustomersection] = useState(
    currentPath.includes("/employee/customer_list") ||
    currentPath.includes("/employee/customer_payment_list")
  );

  const toggleSidebar = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    localStorage.setItem("sidebarOpen", JSON.stringify(newIsOpen));
  };


  const handleEmployeeSectionClick = () => setopenemployeesection(!openemployeesection);
  const handleCustomerSectionClick = () => setopencustomersection(!opencustomersection);
  const handleAccountClick = () => setOpenAccount(!openAccount);


  useEffect(() => {
    const storedSidebarState = localStorage.getItem("sidebarOpen");
    if (storedSidebarState) {
      setIsOpen(JSON.parse(storedSidebarState));
    }
  }, []);

  const getLinkStyles = (path) => ({
    backgroundColor: currentPath === path ? "#99cccc" : "transparent",
    fontWeight: currentPath === path ? "bold" : "normal",
    borderRadius: "20px",
    color: '#000',
    marginTop: "5px",
  });


  const handlelogout = () => {
    logout();
  };

  const [openProfileModal, setOpenProfileModal] = useState(false);

  const handleOpenProfile = () => {
    setOpenProfileModal(true);
  };

  const handleCloseProfile = () => {
    setOpenProfileModal(false);
  };

  return (
    <div
      className="employee-sidebar"
      style={{ display: "flex", paddingBottom: "10px" }}
    >
      <>
        <div
          className={`sidebar ${isOpen ? "open" : ""}`}
          style={{
            width: isOpen ? "269px" : "60px",
            transition: "width",
          }}
        >

          <List className="list" component="nav">

            <div style={{ paddingBottom: "90px" }}>
              <ListItem>
                <MenuIcon
                  onClick={toggleSidebar}
                  sx={{ fontSize: 35, color: "black", cursor: "pointer" }}
                />
              </ListItem>
            </div>

            <ListItem
              button
              component="a"
              href="/employee/dashboard"
              className="list-item-main"
              sx={{
                ...getLinkStyles("/dashboard"),
              }}
            >
              <Tooltip title={!isOpen ? "Dashboard" : ""} placement="right">

                <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }} >
                  <HomeIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon_emp" />
                </ListItemIcon>
              </Tooltip>
              {isOpen && (
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ fontSize: "1.1rem" }}>
                      Dashboard
                    </Typography>
                  }
                  sx={{
                    fontWeight: "normal",
                  }}
                />
              )}
            </ListItem>

            <ListItem
              button
              onClick={handleEmployeeSectionClick}
              component="a"
              href={isOpen ? undefined : "/employee/add_employee"}
              className="list-item-main"
            >
              <Tooltip title={!isOpen ? "Employee Section" : ""} placement="right">
                <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                  <BadgeOutlinedIcon sx={{ fontSize: 30 }} className="ds_sidenav_icon_emp" />
                </ListItemIcon>
              </Tooltip>
              {isOpen && (
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ fontSize: "1.1rem" }}>
                      Employee Section
                    </Typography>
                  }
                />
              )}
              {isOpen && (openemployeesection ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
            </ListItem>


            <Collapse in={openemployeesection && isOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  component="a"
                  className="list-item"
                  href="/employee/add_employee"
                  sx={{
                    ...getLinkStyles("/employee/add_employee"),
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography variant="body2">Add Employee</Typography>
                    }
                  />
                </ListItem>

                <ListItem
                  button
                  component="a"
                  className="list-item"
                  href="/employee/employee_list"
                  sx={{
                    ...getLinkStyles("/employee/employee_list"),
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography variant="body2">Employee List</Typography>
                    }
                  />
                </ListItem>

                

                <ListItem
                  button
                  component="a"
                  href="/employee/employee_tree"
                  className="list-item"
                  sx={{
                    ...getLinkStyles("/employee/employee_tree"),
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography variant="body2">Employee Tree</Typography>
                    }
                  />
                </ListItem>

                <ListItem
                  button
                  component="a"
                  href="/employee/employee_wallet_amount"
                  className="list-item"
                  sx={{
                    ...getLinkStyles("/employee/employee_wallet_amount"),
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography variant="body2">Employees Wallet Amount </Typography>
                    }
                  />
                </ListItem>
                <ListItem
                  button
                  component="a"
                  href="/employee/employee_wallet_transcation_list"
                  className="list-item"
                  sx={{
                    ...getLinkStyles("/employee/employee_wallet_transcation_list"),
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography variant="body2"> Employees Wallet Amount Transcation List</Typography>
                    }
                  />
                </ListItem>
              </List>
            </Collapse>

            {/* Customer  Section*/}
            <ListItem
              button
              onClick={handleCustomerSectionClick}
              component="a"
              href={isOpen ? undefined : "/employee/customer_list"}
              className="list-item-main"
            >
              <Tooltip title={!isOpen ? "Customer Section" : ""} placement="right">
                <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                  <PeopleOutlinedIcon  sx={{ fontSize: 30 }} className="ds_sidenav_icon_emp" />
                </ListItemIcon>
              </Tooltip>
              {isOpen && (
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ fontSize: "1.1rem" }}>
                      Customer Section
                    </Typography>
                  }
                />
              )}
              {isOpen && (opencustomersection ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
            </ListItem>

            <Collapse in={opencustomersection && isOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
              <ListItem
                  button
                  component="a"
                  className="list-item"
                  href="/employee/customer_list"
                  sx={{
                    ...getLinkStyles("/employee/customer_list"),
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography variant="body2">Customer List</Typography>
                    }
                  />
                </ListItem>
                <ListItem
                  button
                  component="a"
                  href="/employee/customer_payment_list"
                  className="list-item"
                  sx={{
                    ...getLinkStyles("/employee/customer_payment_list"),
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography variant="body2">Customer Payment List</Typography>
                    }
                  />
                </ListItem>
              </List>
            </Collapse>


            {/* Account Settings Dropdown */}
            <ListItem
              button
              onClick={() => {
                handleAccountClick();
              }}
              component="a"
              href={isOpen ? undefined : "/employee/change_password"}
              className="list-item-main"
            >
              <Tooltip title={!isOpen ? "Account Settings" : ""} placement="right">

                <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                  <SettingsIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon_emp" />
                </ListItemIcon>
              </Tooltip>

              {isOpen && (
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ fontSize: "1.1rem" }}>
                      Account Settings
                    </Typography>
                  }
                />
              )}
              {isOpen &&
                (openAccount ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
            </ListItem>

            <Collapse in={openAccount && isOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  component="a"
                  href="/employee/change_password"
                  className="list-item"
                >
                  <ListItemText
                    primary={
                      <Typography variant="body2">Change Password</Typography>
                    }
                  />
                </ListItem>
                <ListItem button component="a" className="list-item" onClick={handlelogout} >
                  <ListItemText
                    primary={<Typography variant="body2">Logout</Typography>}
                  />
                </ListItem>
              </List>
            </Collapse>
          </List>
        </div>
      </>
      <div
        id="main"
        style={{
          marginLeft: isOpen ? "269px" : "60px",
          flex: 1,
        }}
      >
        <div
          className="navbar"
          style={{
            left: isOpen ? "269px" : "60px", // Offset for sidebar
            zIndex: 10, // Keep header above content
            // backgroundColor: "white",
          }}
        >

          <div className="heading">
            <span className="company_heading">
              RAJASREE TOWNSHIPS
            </span>
          </div>


          <div>
            <Tooltip title={`profile`} placement="left">
              <AccountCircleIcon
                sx={{
                  fontSize: 30,
                  color: "#0DD354",
                  cursor: "pointer",
                  marginRight: isOpen ? "269px" : "50px",
                }}
                onClick={handleOpenProfile}
              />
            </Tooltip>
          </div>
        </div>

        {/* Profile Modal */}
        <Modal
          open={openProfileModal}
          onClose={handleCloseProfile}
          aria-labelledby="employee-profile-modal"
          aria-describedby="employee-profile-details"
        >
          <Box
            sx={{
              position: "absolute",
              top: 50,
              right: 0,
              width: 315, // Adjust width as needed
              height: "900",
              bgcolor: "whitesmoke",
              boxShadow: 24,
              p: 4,
              borderRadius: "0 0 0 10px", // Rounded bottom-left corner
              overflow: "auto",
            }}
          >
            

            <Table className="profile-table">
              <tr >
                <td colSpan="2"><h6 style={{fontWeight:"bold"}}>{employee.fullName}</h6></td>
              </tr>
              <tr>
                <td>Mobile :</td>
                <td>{employee.mobile}</td>
              </tr>
              <tr>
                <td>Designation:</td>
                <td>{employee.designation}</td>
              </tr>
              <tr>
                <td>Address :</td>
                <td>{employee.address}</td>
              </tr>
              <tr>
                <td>ID :</td>
                <td>{employee.employeeReferenceId}</td>
              </tr>
            </Table>
            <div style={{ justifyContent: "center",display:"inline-flex" }}>
              <button style={{ padding: "5px", fontWeight: "bold", backgroundColor: "#566573 ", color: "white", borderRadius: "5px" }} onClick={handlelogout}>
                Logout
              </button>
              <Link href="/employee/change_password">
                <button style={{ padding: "5px", fontWeight: "bold", backgroundColor: "green", color: "white", borderRadius: "5px", marginLeft: "5px" }}>
                  Change Password
                </button>
              </Link>
            </div>

          </Box>
        </Modal>

        <section className="main" style={{ overflow: "hidden" }}>
          {children}
        </section>
      </div>
    </div>
  );
};
export default Base;
